export var SAVE_OUTCOME_UNKNOWN = 'SAVE_OUTCOME_UNKNOWN';
/** Where a possibly created proposal shows up — the `checkList` target for proposal creates. */
export var PROPOSALS_LIST_HREF = '/czna-authorities/proposals';
export var saveOutcomeUnknownError = function (message, recovery) { return Object.assign(new Error(message), {
    name: 'SaveOutcomeUnknownError',
    code: SAVE_OUTCOME_UNKNOWN,
    recovery: recovery,
}); };
/** Brand check — never `instanceof`, see the file header. */
export var isSaveOutcomeUnknownError = function (error) { return (typeof error === 'object'
    && error !== null
    && error.code === SAVE_OUTCOME_UNKNOWN
    && typeof error.recovery === 'object'
    && error.recovery !== null
    && typeof error.message === 'string'); };
/** The banner content for a value a save rejected with. */
export var toSaveFailure = function (error, fallback) {
    if (isSaveOutcomeUnknownError(error))
        return error;
    return error instanceof Error && error.message ? error.message : fallback;
};
/**
 * The version comparison every `verify` makes: did the stored version move away from the one
 * the timed-out save was sent against? A read that brought no usable version decides nothing.
 */
export var verificationFromVersions = function (sent, stored) {
    if (typeof stored !== 'number')
        return 'unverified';
    return stored !== sent ? 'saved' : 'notSaved';
};
